import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { BydRhsAbstractService } from '../../../shared/services/byd-rhs-abstract.service';
import { ReprographyResponseInterface } from '../interfaces/reprography-response.interface';
import { ReprographyModel } from '../models/reprography-response.model';

@Injectable({
  providedIn: 'root',
})
export class ReprographyService extends BydRhsAbstractService {
  /**
   *
   */
  public path: string;

  /**
   *
   * @param reprographyId - id of reprography
   * @returns - email
   */
  public edmReprography(reprographyId: string): Observable<ReprographyModel> {
    this.path = `/v1/biedm/reprography/${reprographyId}`;
    return this.postModel<ReprographyModel>();
  }

  /**
   * Create ReprographyModel instance.
   *
   * @param  jsonObject The flat json object.
   * @returns an `ReprographyModel` instance.
   */
  public createNewInstance(jsonObject: ReprographyResponseInterface): ReprographyResponseInterface {
    return new ReprographyModel(jsonObject);
  }
}
